import actions from "@/store/wedding/actions";
import state from "@/store/wedding/states";
import mutations from "@/store/wedding/mutations";

const WeddingModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default WeddingModule;